<script>
/**
 * Sales Analytics component
 */
export default {
  data() {
    return {
      analyticData:null,
      series: [],
      chartOptions: {
        chart: {
          height: 230,
          type: "donut"
        },
        labels: ["Supplier assigned", "supplier charges", "profit",],
        plotOptions: {
          pie: {
            donut: {
              size: "75%"
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        colors: ["#5664d2", "#1cbb8c", "#eeb902"]
      }
    };
  },
  mounted() {
    this.getAnalyticsData()
  },
  methods: {
    async getAnalyticsData() {
      try {
        const response = await this.$store.getters.client.get(`/order/admin-dashboard/`);
        console.log(response)
        const margin = response.data.markup_margin
        this.series = [margin?.total_assigned_order_item,margin?.total_supplier_assigned_item, margin?.profit]
        this.analyticData = margin;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4">Sales Report</h4>
      <div id="donut-chart" class="apex-charts"></div>
      <apexchart
        class="apex-charts"
        height="230"
        dir="ltr"
        :series="series"
        :options="chartOptions"
      ></apexchart>
      <div class="row">
        <div class="col-4">
          <div class="text-center mt-4">
            <p class="mb-2 text-truncate">
              <i class="mdi mdi-circle text-primary font-size-10 mr-1"></i>Total Assigned
            </p>
            <h5>&#163;{{ analyticData?.total_assigned_order_item }}</h5>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center mt-4">
            <p class="mb-2 text-truncate">
              <i class="mdi mdi-circle text-success font-size-10 mr-1"></i>Supplier Charged
            </p>
            <h5>&#163;{{ analyticData?.total_supplier_assigned_item }}</h5>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center mt-4">
            <p class="mb-2 text-truncate">
              <i class="mdi mdi-circle text-warning font-size-10 mr-1"></i>Net Profit
            </p>
            <h5>&#163;{{analyticData?.profit}}</h5>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center mt-4">
            <p class="mb-2 text-truncate">
              <i class="mdi mdi-circle text-info font-size-10 mr-1"></i>Markup
            </p>
            <h5>{{analyticData?.markup.toFixed(2)}}%</h5>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center mt-4">
            <p class="mb-2 text-truncate">
              <i class="mdi mdi-circle text-secondary font-size-10 mr-1"></i>Margin
            </p>
            <h5>{{analyticData?.margin?.toFixed(2)}}%</h5>
          </div>
        </div>
      </div>
    </div>
  </div>

  
</template>